module.exports = __webpack_public_path__ + "static/media/cq_carica.b7ebbe55.svg";